export default "__VITE_ASSET__xxEFEODg__"